"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBlock = void 0;
const react_1 = __importDefault(require("react"));
const spa_core_1 = require("@episerver/spa-core");
const TextBlock = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const blockCssClasses = ['TextBlock', (_a = props.data.topMargin) === null || _a === void 0 ? void 0 : _a.value, (_b = props.data.bottomMargin) === null || _b === void 0 ? void 0 : _b.value];
    const cssClasses = ['col-12', (_c = props.data.fontColor) === null || _c === void 0 ? void 0 : _c.value];
    const mainBodyMaxWidth = (_d = props.data.mainBodyWidth) === null || _d === void 0 ? void 0 : _d.value;
    cssClasses.push(mainBodyMaxWidth);
    if (((_e = props.data.backgroundColor) === null || _e === void 0 ? void 0 : _e.value) !== '' && ((_f = props.data.backgroundColor) === null || _f === void 0 ? void 0 : _f.value) !== 'transparent')
        cssClasses.push(`py-3`);
    const styles = {};
    if (((_g = props.data.backgroundColor) === null || _g === void 0 ? void 0 : _g.value) && props.data.backgroundColor.value !== '')
        styles.backgroundColor = props.data.backgroundColor.value;
    //Directly output the mainBody
    return react_1.default.createElement("div", Object.assign({ className: blockCssClasses.join(' '), "data-glenabled": (_h = props.data.enableGlossary) === null || _h === void 0 ? void 0 : _h.value }, (((_j = props.data.blockLanguage) === null || _j === void 0 ? void 0 : _j.value) !== '' ? { lang: (_k = props.data.blockLanguage) === null || _k === void 0 ? void 0 : _k.value } : null)),
        react_1.default.createElement("div", { className: 'row', style: styles },
            react_1.default.createElement(spa_core_1.Components.Property, { className: cssClasses.join(' '), iContent: props.data, field: "mainBody" })),
        ((_l = props.data.showBorder) === null || _l === void 0 ? void 0 : _l.value) ?
            react_1.default.createElement("div", { className: 'row' },
                react_1.default.createElement("div", { className: 'col-12' },
                    react_1.default.createElement("div", { className: (_m = props.data.showBorder) === null || _m === void 0 ? void 0 : _m.value })))
            : react_1.default.createElement(react_1.default.Fragment, null));
};
exports.TextBlock = TextBlock;
exports.default = exports.TextBlock;
